import { Container, Divider } from "@material-ui/core";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  DateTimeDisplay,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
  SelectInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl, hardTypeWeb } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDateTime, getCookie, getErrors } from "utils";
import ModalFormExchangeRate from "./Components/ModalFormExchangeRate";

function ExchangesRate() {
  const classes = globalStyles();
  const history = useHistory();
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  const isMpis = hardTypeWeb === "mpis";
  const token = localStorage.getItem("token");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const paramsSearch = urlParams?.get("search") || "";
  const paramsPage = urlParams?.get("page") || 1;
  const paramsSize = urlParams?.get("per_page") || 10;
  const paramsCurrency = urlParams?.get("currency_id") || "";

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    per_page: Number(paramsSize) || 10,
    search: paramsSearch || "",
    currency_id: Number(paramsCurrency) || "",
    ...(!isMpis && { publisher_id: userLogin?.publisher?.publisher_id }),
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionCurrency, setOptionCurrency] = useState([]);
  const selectedCurrency = selectedId =>
    optionCurrency?.find(option => option.id === selectedId);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalPreload, setModalPreload] = useState(null);

  const isAfter = date => moment(date)?.isAfter(moment().add(15, "minutes"));

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };
  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleCreate = () => {
    if (queryParams?.currency_id) {
      setModalPreload({
        currency_id: queryParams?.currency_id,
        currency: selectedCurrency(queryParams?.currency_id)?.currency_iso_code,
      });
      setModalVisible(true);
    } else {
      ModalError("Please Select Currency");
    }
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/exchange-rate/datatable`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const getOptionCurrency = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/currency/datatable?per_page=99&page=1`,
        { headers }
      );
      setOptionCurrency(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const deleteCurrency = async id => {
    try {
      await axios.delete(`${hardBaseUrl}/exchange-rate/delete/${id}`, {
        headers,
      });
      ModalSuccess("Successfully End Exchange Rate").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  useEffect(() => {
    getOptionCurrency();
  }, []);

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Exchanges Rate">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <SelectInput
                  label="Currrency"
                  options={optionCurrency}
                  optionKey="id"
                  optionLabel="currency_iso_code"
                  value={queryParams?.currency_id || ""}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "currency_id")
                  }
                  placeholder="None"
                  width={250}
                  disabled={loadingPage}
                />
              </Grid>
              <Grid item>
                <PrimaryButton
                  label="Create Exchanges Rate"
                  onClick={handleCreate}
                  disabled={loadingPage}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable({ selectedCurrency })}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "per_page")
          }
          isHaveAction
          handleView={item =>
            history.push(
              `/admin/konfigurasi/exchange-rate/view/${item?.id}/${
                selectedCurrency(item?.currency_id)?.currency_iso_code
              }`
            )
          }
          tooltipView="Details"
          deleteConfirmation
          deleteConfirmationTitle="End Period Exchange Rate"
          deleteConfirmationContent={item =>
            `Are you sure you want to end period of this Exchange Rate (${selectedCurrency(
              item?.currency_id
            )?.currency_iso_code || "-"} at ${formatDateTime(
              item?.start_date
            )})`
          }
          handleDelete={item => deleteCurrency(item?.id)}
          disabledDelete={item => !isAfter(item?.end_date)}
          tooltipDelete="End Period"
        />
      </Container>
      {modalVisible && (
        <ModalFormExchangeRate
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          preload={modalPreload}
          getDataTable={getDataTable}
        />
      )}
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/exchange-rate",
  },
  {
    label: "Exchange Rate",
    active: true,
  },
];
const columnTable = ({ selectedCurrency }) => [
  {
    name: "currency_id",
    title: "Currency",
    renderText: item => selectedCurrency(item)?.currency_iso_code || "-",
  },
  {
    name: "start_date",
    title: "Start Date",
    renderText: date => <DateTimeDisplay date={date} />,
  },
  {
    name: "end_date",
    title: "End Date",
    renderText: date => <DateTimeDisplay date={date} />,
  },
  {
    name: "value",
    title: "Exchange Rate",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp" decimalScale={2} />
    ),
  },
];
export default ExchangesRate;
